// src/components/CategoryTabs.jsx
import React from "react";
import { motion } from "framer-motion";
const tabsParent = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1,
    },
  },
};

const tabVariant = {
  hidden: { opacity: 0, y: 24, scale: 0.95 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.5,
      type: "spring",
      bounce: 0.3,
    },
  },
};

export default function CategoryTabs({
  categories,
  activeCategory,
  onCategoryChange,
}) {
  return (
    <div className="max-w-5xl mx-auto mb-10">
      <motion.div
        className="flex flex-wrap justify-center gap-4"
        variants={tabsParent}
        initial="hidden"
        whileInView="show"
        viewport={{ once: false, amount: 0.2 }}
      >
        {categories.map((cat) => (
          <motion.button
            key={cat.id}
            variants={tabVariant}
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.96 }}
            onClick={() => onCategoryChange(cat.id)}
            className={`px-6 py-3 rounded-2xl text-sm md:text-base font-semibold
              transition-all duration-300 text-white/70
              ${
                activeCategory === cat.id
                  ? "bg-gradient-to-r from-[var(--bg)] to-[var(--bg2)] text-white shadow-lg shadow-blue-500/30"
                  : "bg-black text-slate-700 border border-slate-200 hover:shadow-md"
              }`}
          >
            {cat.label} 
          </motion.button>
        ))}
      </motion.div>
    </div>
  );
}
